<template>
  <header class="nav background" style="border-bottom: 1px;">
    <div class="nav-left">
      <img src="@/assets/logo.png" style="max-width: 90px; height: auto;" />
      <span class="nav-item">
        <router-link to="/main/Home" style="font-size: 24px; color: #FFF;">スケジュール管理システム Philips SMS</router-link>
      </span>
    </div>
    <div class="nav-right" style="color: #FFF;">
      <span class="nav-item" style="font-size: 13px;">最終ログイン日時：{{ lastLogin }}</span>
      <span class="nav-item">
        <button
          class="button is-primary"
          type="button"
          slot="trigger"
          @click="help('患者点検管理システム操作マニュアル.pdf')"
        >
          <b-icon icon="help-circle"></b-icon>
          <span>ヘルプ</span>
        </button>
      </span>
      <span class="nav-item" v-if="ssoLogin">
          <button class="button is-primary" style="pointer-events: none" type="button" slot="trigger">
            <b-icon icon="account"></b-icon>
            <span>{{ getuserName(userName) }}</span>
          </button>
      </span>
      <span class="nav-item" v-if="!ssoLogin">
        <b-dropdown aria-role="list">
          <button class="button is-primary" type="button" slot="trigger">
            <b-icon icon="account"></b-icon>
            <span>{{ getuserName(userName) }}</span>
            <b-icon icon="menu-down"></b-icon>
          </button>
          <b-dropdown-item aria-role="listitem" @click="showPasswordChangeActive">パスワード変更</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" @click="showQRcodeViewActive">QRコード表示</b-dropdown-item>
        </b-dropdown>
      </span>
      <span class="nav-item" v-if="fromPC">
        <button v-if="patientDb.disable" class="button is-primary" type="button" slot="trigger" @click="logout">
          <b-icon icon="logout"></b-icon>
          <span>ログアウト</span>
        </button>
        <b-dropdown v-else aria-role="list">
          <button class="button is-primary" type="button" slot="trigger">
            <b-icon icon="logout"></b-icon>
            <span>ログアウト</span>
            <b-icon icon="menu-down"></b-icon>
          </button>
          <b-dropdown-item aria-role="listitem" @click="logout">ログアウト</b-dropdown-item>
          <b-dropdown-item 
            v-for="subSystem in changeSubSystemMenu"
            :key="subSystem.id"
            aria-role="listitem"
            @click="changeSubSystem(subSystem)">
            {{ subSystem.name + "切替" }}
          </b-dropdown-item>
        </b-dropdown>
      </span>
    </div>
    <b-modal :active.sync="isPasswordChangeActive" has-modal-card>
      <passwordChange-modal></passwordChange-modal>
    </b-modal>
    <b-modal :active.sync="isQRcodeViewActive" has-modal-card>
      <qrcodeView-modal></qrcodeView-modal>
    </b-modal>
  </header>
</template>

<script>
import pdf from "@/assets/pdf/manual.pdf";
const PasswordChangeForm = {
  props: [],
  methods: {
    changePassword: function() {
      // TODO パスワードハッシュ化
      this.$validator.validateAll().then(result => {
        if (result) {
          var excuteApi = this.passwordresetPOST;
          var successCallBack = this.passwordresetSuccess;
          var errorCallBack = this.passwordresetError;
          // WebAPI Call
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        }
      });
    },
    passwordresetPOST: function(client) {
      return client.apis.auth.passwordresetPOST({
        body: {
          currentpassword: this.currentpassword,
          newpassword: this.newpassword
        }
      });
    },
    passwordresetSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.showSuccess(result);
      this.$parent.close();
    },
    passwordresetError: function(result) {
      this.showErrorMessage(result);
    }
  },
  data() {
    return {
      currentpassword: "",
      newpassword: "",
      newpasswordcomf: ""
    };
  },
  template: `
        <div class="modal-card" style="width: 500px;">
          <header class="modal-card-head">
              <p class="modal-card-title" style="color: whitesmoke;">パスワード変更</p>
          </header>
          <section class="modal-card-body" style="border: 1px solid #dbdbdb;">
            <b-field label="変更前パスワード" :type="{'is-danger': errors.has('befourPassword')}" :message="errors.first('befourPassword')">
              <b-input
                name="befourPassword"
                data-vv-as="変更前パスワード"
                type="password"
                v-model="currentpassword"
                password-reveal
                placeholder="変更前パスワードを入力してください"
                v-validate="'required|min:8|max:16'"
              ></b-input>
            </b-field>
            <b-field label="変更後パスワード" :type="{'is-danger': errors.has('afterPassword')}" :message="errors.first('afterPassword')">
                <b-input
                  name="afterPassword"
                  data-vv-as="変更後パスワード"
                  type="password"
                  ref="afterPassword"
                  v-model="newpassword"
                  password-reveal
                  placeholder="変更後パスワードを入力してください"
                  v-validate="'required|min:8|max:16|password'"
                ></b-input>
            </b-field>
            <b-field label="変更後パスワード(確認)" :type="{'is-danger': errors.has('afterPasswordcomf')}" :message="errors.first('afterPasswordcomf')">
              <b-input
                name="afterPasswordcomf"
                data-vv-as="変更後パスワード(確認)"
                type="password"
                v-model="newpasswordcomf"
                password-reveal
                placeholder="変更後パスワード(確認)を入力してください"
                v-validate="'required|confirmed:afterPassword'"
              ></b-input>
            </b-field>
            <div style="height: 30px;" />
          </section>
          <footer class="modal-card-foot">
            <div>
              <b-button
                class="button is-primary is-inverted has-text-centered"
                icon-left="keyboard-backspace"
                type="button"
                v-on:click="$parent.close()"
              >
              戻る
              </b-button>
              <b-button
                class="button is-light is-inverted has-text-centered"
                icon-left="key-change"
                v-on:click="changePassword()"
              >パスワード変更</b-button>
            </div>
          </footer>
        </div>
      `
};
const QRcodeViewForm = {
  props: [],
  methods: {
    getQrcode: function() {
      var excuteApi = this.qrcodePOST;
      var successCallBack = this.qrcodeSuccess;
      var errorCallBack = this.qrcodeError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    qrcodePOST: function(client) {
      return client.apis.auth.qrcodePOST({
        body: {}
      });
    },
    qrcodeSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      var QrcodeTag = result.obj.qrcode;
      document
        .getElementById("qrcode")
        .insertAdjacentHTML("afterbegin", QrcodeTag);
    },
    qrcodeError: function(result) {
      // 処理なし
    }
  },
  data() {
    return {};
  },
  mounted: function() {
    // WebApi Call
    this.getQrcode();
  },
  template: `
        <div class="modal-card" style="width: 500px;">
          <header class="modal-card-head">
              <p class="modal-card-title" style="color: whitesmoke;">QRコード表示</p>
          </header>
          <section class="modal-card-body" style="border: 1px solid #dbdbdb;">
            <div id="qrcode">
            </div>
          </section>
          <footer class="modal-card-foot">
            <div>
              <b-button
                class="button is-primary is-inverted has-text-centered"
                icon-left="keyboard-backspace"
                type="button"
                v-on:click="$parent.close()"
              >
              戻る
              </b-button>
            </div>
          </footer>
        </div>
      `
};

/**
 * Base64とMIMEコンテンツタイプからBlobオブジェクトを作成する。
 *
 * @param base64
 */
function downloadPdf(base64, filename) {
  var mime_ctype = "application/pdf";
  var blob = toBlob(pdf, mime_ctype);
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = decodeURI(filename);
  link.click();
}

/**
 * Base64とMIMEコンテンツタイプからBlobオブジェクトを作成する。
 * 日本語対応。
 *
 * @param base64
 * @param mime_ctype MIMEコンテンツタイプ
 * @returns Blob
 */
function toBlob(base64, mime_ctype) {
  // 日本語の文字化けに対処するためBOMを作成する。
  var bom = new Uint8Array([0xef, 0xbb, 0xbf]);
  var bin = atob(base64.replace(/^.*,/, ""));
  var buffer = new Uint8Array(bin.length);
  for (var i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }
  // Blobを作成
  try {
    var blob = new Blob([bom, buffer.buffer], {
      type: mime_ctype
    });
  } catch (e) {
    return false;
  }
  return blob;
}

import * as subSystem from '../../utils/subSystem'
export default {
  name: "header",

  computed: {
    changeSubSystemMenu: function() {
      const changeSubSystemMenu = subSystem.getChangeMenu(this.$store.state.subSystem);
      return changeSubSystemMenu;
    }
  },

  methods: {
    getuserName: function(value) {
      var length = 20;
      return value.length > length ? value.substr(0, length) + "..." : value;
    },
    logout: function(event) {
      var guardianToken = sessionStorage.getItem("guardianToken");
      var ssologin = JSON.parse(sessionStorage.getItem('userInfo')).ssologin

      if(guardianToken) {
          sessionStorage.removeItem("guardianToken");
      }
      this.$store.dispatch("logout", {token: guardianToken,ssologin}).then(() => {
        if (ssologin === true){
              window.location.href = this.$store.state.ssoLogoutUrl;
        } else {
          this.$router.push("/");
        }
      });
    },
    showPasswordChangeActive: function(event) {
      this.isPasswordChangeActive = true;
    },
    showQRcodeViewActive: function(event) {
      this.isQRcodeViewActive = true;
    },
    help: function(filename) {
      // マニュアルのURLにリンク
      downloadPdf(pdf, filename);
    },

    changeSubSystem: function(subSystem) {
      this.$store.dispatch("changeSubSystem", subSystem);
      this.$router.push({name: "Home",});

      return;
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var ua = navigator.userAgent;
    var fromPC = !(
      ua.indexOf("iPhone") > 0 ||
      ua.indexOf("Android") > 0 ||
      ua.indexOf("iPad") > 0
    );
    var ssoLogin = this.$store.state.isSSOLogin;
    return {
      fromPC: fromPC,
      isPasswordChangeActive: false,
      isQRcodeViewActive: false,
      userName: userInfo.fullName,
      lastLogin: sessionStorage.getItem("lastLoginDate"),
      pdf: pdf,
      patientDb: userInfo.system.patientDb,
      ssoLogin: ssoLogin,
    };
  },
  components: {
    "passwordChange-modal": PasswordChangeForm,
    "qrcodeView-modal": QRcodeViewForm
  }
};
</script>

<style>
.nav {
  z-index: 10;
}
.navbar {
  flex: 0;
}

.site-header {
  left: 0;
  top: 0;
  width: 100%;
  height: 60px;
  padding: 12px 15px;
  z-index: 1000;
  position: fixed;
  text-align: left;
  vertical-align: middle;
}
.header-right {
  float: right;
}

.background {
  background: linear-gradient(
    45deg,
    rgba(0, 0, 139, 0.7) 0%,
    rgba(0, 52, 120, 0.7) 100%
  );
  background: -moz-linear-gradient(
    45deg,
    rgba(0, 0, 139, 0.7) 0%,
    rgba(0, 52, 120, 0.7) 100%
  );
  background: -webkit-linear-gradient(
    45deg,
    rgba(0, 0, 139, 0.7) 0%,
    rgba(0, 52, 120, 0.7) 100%
  );
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/home/header.vue